import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react/components/common/Tooltip/Tooltip';
import { highlightText } from '../utils';

/**
 * Suggestions dropdown component for the input bar
 */
const SuggestionsDropdown = ({
  suggestions,
  selectedIndex,
  currentTag,
  programBlAllowed,
  disableBooleanLogic,
  resultsScrollableRef,
  onClickSuggestion,
  onDefineInterest,
  tags,
}) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="results">
      <div ref={resultsScrollableRef} className="results-scrollable">
        <div className={`suggestions ${programBlAllowed ? 'suggestions-wrapper' : ''}`}>
          {programBlAllowed && <div className="suggestion-title">Suggested Phrases</div>}
          <div className="scrollable-suggestions">
            {suggestions.slice(1).map((suggest, index) => (
              <div
                key={index}
                className={`result ${selectedIndex === index + 1 ? 'selected' : ''}`}
                onMouseDown={() => onClickSuggestion(suggest)}
              >
                <Tooltip content={suggest.text}>
                  <div className="suggestion-content">
                    <span>{highlightText(suggest.text, currentTag.trim())}</span>
                    {suggest.payload?.type && <span className="suggestion-type">({suggest.payload.type})</span>}
                  </div>
                </Tooltip>
              </div>
            ))}
          </div>
        </div>
      </div>
      {!disableBooleanLogic && (
        <div className="define-interest">
          <button
            className="main-button blue"
            onMouseDown={(e) => {
              e.preventDefault();
              if (onDefineInterest) {
                onDefineInterest(tags);
              }
            }}
          >
            Define an interest
          </button>
        </div>
      )}
    </div>
  );
};

SuggestionsDropdown.propTypes = {
  suggestions: PropTypes.array.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  currentTag: PropTypes.string,
  programBlAllowed: PropTypes.bool,
  disableBooleanLogic: PropTypes.bool,
  resultsScrollableRef: PropTypes.object,
  onClickSuggestion: PropTypes.func.isRequired,
  onDefineInterest: PropTypes.func,
  tags: PropTypes.array,
};

export default SuggestionsDropdown;
